module.exports = __webpack_public_path__ + "img/icon_cancel.8a78a2c3.png";